var exports = {
  "bR": "action-bar-position__viAbCD",
  "DZ": "addCommentButton__h_C4t1",
  "VU": "addCommentButtonDraftCompact__nreRs8",
  "dD": "addCommentButtonDraftRelaxed__6BP6GC",
  "XR": "addCommentButtonNew__zrLl3i",
  "Jj": "actionBarArrowSizing__PsIW6w",
  "hV": "actionBarHeight__6G4Owz",
  "LE": "actionBarStartCommentWidth__hGpI2N",
  "i": "action-bar-button-group__z3FGi6",
  "wO": "action-bar-button-group--no-leading__fkFDxh",
};

module.exports = exports;
